import { TextField, Grid, Box } from '@material-ui/core'
import { useState, useEffect } from 'react'

const TimerSettings = ({examDetails, updateTimerSettings}) => {
  const exam = examDetails.exam

  const [displayFields, setDisplayFields] = useState(exam.time_enabled === 1 ? true : false)
  const [questionPerScreen, setQuestionPerScreen] = useState(exam.question_per_screen ? exam.question_per_screen : '')
  const [secondsPerScreen, setSecondsPerScreen] = useState(exam.seconds_per_screen ? exam.seconds_per_screen : '')

  const handleToggle = (e) => {
    setDisplayFields(e.target.checked)
  }

  useEffect(() => {

    updateTimerSettings({displayFields, questionPerScreen, secondsPerScreen})

  }, [displayFields, questionPerScreen, secondsPerScreen, updateTimerSettings])

  return (
    <>
      <Box marginBottom={displayFields ? 0 : 3}>
        <input
          id="enable_timed_exam"
          type="checkbox"
          onChange={handleToggle}
          checked={displayFields}
        /> <label htmlFor="enable_timed_exam">Enable timed examination</label>
      </Box>
      <Grid item container style={{display: displayFields ? 'flex' : 'none'}}>
        <TextField
          id="questionsPerScreen"
          label="Questions Per Screens"
          value={questionPerScreen}
          onChange={(e) => setQuestionPerScreen(e.target.value)}
          fullWidth
        />
        <TextField
          id="secondsPerScreen"
          label="Time Per Screen (in seconds)"
          value={secondsPerScreen}
          onChange={(e) => setSecondsPerScreen(e.target.value)}
          fullWidth
        />
      </Grid>
    </>
  )
}

export default TimerSettings